import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return environment.baseHref;
}

export function getApiUrl() {
  return environment.apiUrl;
}

export function getAlddaMXUrl() {
  return environment.alddaMxUrl;
}

export function getNotificationUrl() {
  return environment.notificationUrl;
}

export function getImagesUrl() {
  return environment.imagesUrl;
}

export function getZorbekSepomexApiUrl() {
  return environment.zorbekSepomexApiUrl;
}


export function getAlddaEmbedUrl() {
  return environment.alddaEmbedUrl;
}

const providers = [
  { provide: 'NOTIFICATION_URL', useFactory: getNotificationUrl, deps: [] },
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] },
  { provide: 'API_URL', useFactory: getApiUrl, deps: [] },
  { provide: 'IMAGES_URL', useFactory: getImagesUrl, deps: [] },
  { provide: 'ZORBEK_SEPOMEX_URL', useFactory: getZorbekSepomexApiUrl, deps: [] },
  { provide: 'ALDDA_MX_URL', useFactory: getAlddaMXUrl, deps: [] },
  { provide: 'ALDDA_EMBED_URL', useFactory: getAlddaEmbedUrl, deps: [] },
];

if (environment.production) {
  enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic(providers)
    .bootstrapModule(AppModule)
    .catch((err) => {});
});
